import React, { useEffect, useReducer } from "react";

import { DocumentTemplateApi, documentTemplatesApi } from "api";
import { routes } from "consts";
import { useNavigate } from "react-router-dom";
import { AdminResourceDeleteModal, PageMain, FiltersBackground, AdminSearchInput } from "components/molecules";
import { PageRichHeader } from "components/molecules/PageHeader/PageRichHeader";
import { PaziaButton } from "components/atoms";
import {
  TanTable,
  TanTableColumn,
  useFilters,
  usePagination,
  useSorting,
} from "components/molecules";
import { useDocumentTemplates } from "api/hooks";
import { useDeleteResourceActions } from "utils/store";

export const DocumentsPage = (): JSX.Element | null => {
  const { setDeleteResource } = useDeleteResourceActions();
  const { searchPhrase, filter, setSearchPhrase } = useFilters();
  const { limit, onPaginationChange, skip, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();
  const { isLoading, isFetching, documentTemplates, total, invalidate } = useDocumentTemplates(
    skip,
    limit,
    searchPhrase,
    filter,
    fieldWithOrder,
  );

  useEffect(() => {
    invalidate();
  }, [sorting, pagination, searchPhrase, filter]);

  const navigate = useNavigate();

  const columns = React.useMemo<TanTableColumn<DocumentTemplateApi>[]>(
    () => [
      {
        id: "id",
        accessorKey: "id",
        header: "ID",
        enableColumnFilter: false,
        size: 10,
        cell: (info) => info.getValue(),
      },
      {
        id: "name",
        accessorKey: "name",
        header: "Nazwa",
        size: 500,
        enableColumnFilter: false,
      },
    ],
    [],
  );
  return (
    <PageMain>
      <PageRichHeader header="Szablony dokumentów">
        <div className="flex grow justify-between">
          <div>
            <PaziaButton type="primary" title="Dodaj +" onClick={() => navigate(routes.DOCUMENTS_ADD)} />
          </div>
          <div>
            <PaziaButton
              type="tertiary"
              title="Edytuj typy dokumentów"
              onClick={() => navigate(routes.DOCUMENT_TYPES)}
            />
          </div>
        </div>
      </PageRichHeader>

      <FiltersBackground className="mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <AdminSearchInput onSearch={(sp: string) => setSearchPhrase(sp)} className="self-end" />
        </div>
      </FiltersBackground>
      <TanTable
        data={documentTemplates}
        columns={columns}
        total={total}
        loading={isLoading}
        fetching={isFetching}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        onDelete={(x) => setDeleteResource(x.id)}
        pagination={pagination}
        sorting={sorting}
        onRowClick={(x) => navigate(routes.DOCUMENTS_PAGES(x.id))}
        onEdit={(x) => navigate(routes.DOCUMENTS_EDIT(x.id))}
      />
      <AdminResourceDeleteModal
        title="Usuń szablon"
        description="Jesteś pewien że chcesz usunąć szablon?"
        onSuccessDelete={() => invalidate()}
        deleteAction={documentTemplatesApi.delete}
      />
    </PageMain>
  );
};
